import React from 'react';

export const useIntersectionObserver = <T extends HTMLElement = HTMLElement>(
  initialVisibility = false,
  rootMargin?: string
) => {
  const [visible, setVisible] = React.useState<boolean>(initialVisibility);

  const ref = React.useRef<T | null>(null);

  const setRef = React.useCallback(
    (node: T | null) => {
      ref.current = node;
      const observer = new IntersectionObserver(
        ([entry]) => {
          setVisible(entry.isIntersecting);
        },
        { rootMargin: rootMargin }
      );
      if (node !== null) {
        observer.observe(node);
      } else {
        observer.disconnect();
      }
    },
    [rootMargin]
  );

  return [ref, setRef, visible] as const;
};
